var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { TextField, GrayText, TextArea } from "@atlassiansox/microscopekit";
import { RadioGroup } from "@atlaskit/radio";
import { LabelWithHelperText, NumberField, TextSelect } from "../../../../components";
import { JsonInput } from "../../../JsonInput";
import { HelperMessage } from "@atlaskit/form";
export function DynamicFormField(_a) {
    var _b;
    var type = _a.type, suffixMessage = _a.suffixMessage, label = _a.label, labelHelperText = _a.labelHelperText, fieldProps = __rest(_a, ["type", "suffixMessage", "label", "labelHelperText"]);
    var onChangeWithTargetValue = function (e) {
        fieldProps.onChange(e.target.value);
    };
    var labelContent = labelHelperText ? (React.createElement(LabelWithHelperText, { helperText: labelHelperText, label: label, insideHeader: true })) : (label);
    var modifiedFieldProps = __assign(__assign({}, fieldProps), { label: labelContent });
    return (React.createElement(React.Fragment, null,
        type === "text" && (React.createElement(React.Fragment, null,
            React.createElement(TextField, __assign({}, modifiedFieldProps, { value: (_b = modifiedFieldProps.value) !== null && _b !== void 0 ? _b : "", onChange: onChangeWithTargetValue })),
            fieldProps.name === "parameters.target_dns" && (React.createElement(HelperMessage, null,
                "Please refer\u00A0",
                React.createElement("a", { href: "https://developer.atlassian.com/platform/brahmos/infrastructure/blackhole" }, "this"),
                "\u00A0for target configuration")))),
        type === "number" && React.createElement(NumberField, __assign({}, modifiedFieldProps)),
        type === "text-select" && React.createElement(TextSelect, __assign({}, modifiedFieldProps)),
        type === "radio" && (React.createElement(React.Fragment, null,
            labelContent,
            React.createElement(RadioGroup, __assign({}, modifiedFieldProps, { onChange: onChangeWithTargetValue })))),
        type === "textarea" && (React.createElement(TextArea, __assign({}, modifiedFieldProps, { onChange: onChangeWithTargetValue }))),
        type === "json" && React.createElement(JsonInput, __assign({}, modifiedFieldProps)),
        suffixMessage && (React.createElement("div", null,
            React.createElement(GrayText, null, suffixMessage)))));
}
